import { FC } from "react";
import { useTranslation } from "react-i18next";

import { INVESTIGATION_AI_SUGGESTION_KEYS } from "../investigation.constants";
import { AskAiSuggestionsStyled } from "./investigation.ask-ai.styled";

interface IInvestigationAskAiSuggestionsProps {
  /** Sends the tapped question as the user's next message, exactly as if they had typed it. */
  onPick: (question: string) => void;
}

/** Starter questions offered while the Ask-AI transcript is still empty. */
export const InvestigationAskAiSuggestions: FC<
  IInvestigationAskAiSuggestionsProps
> = ({ onPick }) => {
  const { t } = useTranslation();

  return (
    <AskAiSuggestionsStyled>
      <span className="suggestions-title">
        {t("rideMap.investigation.askAi.suggestionsTitle")}
      </span>
      {INVESTIGATION_AI_SUGGESTION_KEYS.map(key => {
        const question = t(`rideMap.investigation.askAi.suggestions.${key}`);

        return (
          <button
            key={key}
            type="button"
            className="suggestion"
            onClick={() => onPick(question)}
          >
            {question}
          </button>
        );
      })}
    </AskAiSuggestionsStyled>
  );
};
